module.exports = __webpack_public_path__ + "static/media/ic_drop_down_gray.33ba0580.svg";